export const initialState = {
	user: {}	
}
